<script setup lang="ts" generic="T extends TextData">

import type { HandlungBausteinProps, TextData } from '@/api/handlungen/types';

defineProps<HandlungBausteinProps<T>>();
</script>

<template>
  <p class="text-gray-700 text-sm md:text-base mb-1">
    {{ baustein.data.text }}
  </p>
</template>
